import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	const authService = inject(AuthService);
	const router = inject(Router);
	if (authService.isAuthenticated()) {
		return true;
	} else {
		const isMobileWidth = typeof window !== 'undefined' && window.innerWidth <= 768;
		const isApp = state.url.startsWith('/app') || isMobileWidth;
		router.navigate([isApp ? '/app/public/login' : '/web/public/login']);
		return false;
	}
};
